export default __webpack_public_path__ + "static/media/Nosotros_imagen1_768.5f1e90b6.jpg";